import React, { Dispatch, SetStateAction, ChangeEvent, useState, useEffect, useContext } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import PrivilegesContext from "../../../../contexts/PrivilegesContext";

interface QIRStatusFieldProps {
    action: "view" | "update" | "create",
    qir: any,
    setQir: Dispatch<SetStateAction<any>>,
    businessUnitDetails: any,
    onChange: (e: ChangeEvent<HTMLElement>) => void,
    formDisabled: boolean,
}

function QIRStatusField({ action, qir, setQir, businessUnitDetails, onChange, formDisabled }: QIRStatusFieldProps) {
    const { t } = useTranslation();
    const { supervisor, admin} = useContext(PrivilegesContext);
    const [selectedStatus, setSelectedStatus] = useState<any>();

    useEffect(() => {
        if (action === "create" && !qir.status) {
            setQir((q: any) => ({
                ...q,
                status: "Open",
            }))
        }
    }, [action, qir?.status, setQir]);

    useEffect(() => {
        if (!businessUnitDetails?.statuses) {
            return;
        }

        if (qir.statusId) {
            const status = businessUnitDetails.statuses.filter((x: any) => x.id === +qir.statusId)[0];
            setSelectedStatus(status);
        } else {
            const status = businessUnitDetails.statuses.filter((x: any) => x.stateName === "Open")[0];
            setSelectedStatus(status);
            // We need to also set the QIR to have the same Status and State as the selected status
            setQir((q: any) => ({
                ...q,
                statusId: status.id,
                stateId: status.stateId
            }));
        }
    }, [qir.statusId, businessUnitDetails?.statuses, setQir]);

    // Filter status list. Only supervisors can close QIRs
    const [statusOptions, setStatusOptions] = useState<any[]>([]);
    useEffect(() => {
        if (!businessUnitDetails?.statuses) {
            return;
        }

        setStatusOptions(supervisor
            ? businessUnitDetails.statuses
            : businessUnitDetails.statuses.filter((x: any) => x.id === qir?.statusId || (x.stateName !== "Closed" && x.stateName !== "Cancelled")));
    }, [qir?.statusId, businessUnitDetails?.statuses, supervisor]);


    return (
        <Form.Group as={Row} className="mb-1" controlId="statusId">
            <Form.Label column sm={3} className="required">{t('QIRDetail.Fields.Status')}</Form.Label>
            <Col sm={9}>
                {!businessUnitDetails || action === "view" || qir.isDeleted
                    ? <Form.Control type="text" size="sm" value={qir.status} name="statusId" onChange={onChange} readOnly />
                    : <Form.Select required size="sm" value={selectedStatus?.id ?? ""} name="statusId" onChange={onChange} disabled={formDisabled && !admin && !supervisor}>
                        <option key="0" value="">{t('Application.Controls.DefaultSelect')}</option>
                        {
                            statusOptions && statusOptions.map((status, i) => {
                                return <option key={i + 1} value={status.id}>{status.display}</option>;
                            })
                        }
                    </Form.Select>
                }
            </Col>
        </Form.Group>
    );
}

export default QIRStatusField;